var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{attrs:{"icon":"","loading":_vm.loading},on:{"click":function($event){$event.stopPropagation();return _vm.handleRemove.apply(null, arguments)}}},[_c('v-icon',{staticClass:"red--text",attrs:{"small":""}},[_vm._v("mdi-delete")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }